import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TopHeaderDirective } from './directives/top-header.directive';
import { MainHeaderDirective } from './directives/main-header.directive';
import { BottomHeaderDirective } from './directives/bottom-header.directive';
import { SocialNavComponent } from './social-nav/social-nav.component';
import { NbActionsModule, NbCardModule, NbContextMenuModule, NbFormFieldModule, NbIconModule, NbInputModule, NbMenuModule, NbPopoverModule, NbSearchModule } from '@nebular/theme';
import { ContactsNavComponent } from './contacts-nav/contacts-nav.component';
import { MessageNavComponent } from './message-nav/message-nav.component';
import { LogoNavComponent } from './logo-nav/logo-nav.component';
import { ToolNavComponent } from './tool-nav/tool-nav.component';
import { SearchNavComponent } from './search-nav/search-nav.component';
import { RemoveChildrenDirective } from './main-nav/remove-children.directive';


@NgModule({
  declarations: [
    TopHeaderDirective,
    MainHeaderDirective,
    BottomHeaderDirective,
    SocialNavComponent,
    ContactsNavComponent,
    MessageNavComponent,
    LogoNavComponent,
    ToolNavComponent,
    SearchNavComponent,
    RemoveChildrenDirective
  ],
  imports: [
    CommonModule,
    NbActionsModule,
    NbIconModule,
    NbFormFieldModule,
    NbSearchModule,
    NbInputModule,
    NbPopoverModule,
    NbMenuModule,
    NbCardModule,
    NbContextMenuModule
  ],
  exports:[SocialNavComponent,ContactsNavComponent,MessageNavComponent,LogoNavComponent,ToolNavComponent,SearchNavComponent,RemoveChildrenDirective]
})
export class HeaderModule { }
